import classNames from 'classnames';
import { useState } from 'react';
import { Checkbox, ImageViewer } from 'tdesign-react';

import { EyesIcon } from '@/components/icon';
import { UserResourceType } from '@/interface/library';

import styles from './index.module.less';

export const LibraryImageViewer: React.FC<{
  children?: React.ReactNode;
  images: string[];
  hover?: boolean;
  defaultIndex?: number;
  checked?: boolean;
  type: UserResourceType | undefined;
  onCheckedChange?: (checked: boolean) => void;
}> = (props) => {
  const {
    images = [],
    defaultIndex,
    checked = false,
    onCheckedChange,
  } = props;
  const filterImages = images.filter(item => item);

  const [hover, setHover] = useState(false);

  const handleChange = (value: boolean) => {
    onCheckedChange?.(value);
  };

  const trigger = ({ open }: { open: () => void }) => {
    const handleOpen = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      open();
    };

    const mask = (
      <div
        onClick={() => handleChange(!checked)}
        style={{
          color: '#fff',
          height: '100%',
          zIndex: 2,
          position: 'absolute',
          width: '100%',
          borderRadius: 6,
        }}
        className={classNames({
          [styles.checked]: checked,
        })}
      >
        {
          hover ? <span className={styles.browseIcon} onClick={handleOpen}>
            <EyesIcon name={'browse'} />
          </span>
            : null
        }

        <span className={styles.checkboxIcon}>
          <Checkbox checked={checked}></Checkbox>
        </span>
      </div>
    );

    return (
      <div>
        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className={classNames(styles.content, { [styles.active]: checked })}
        >
          {props.children}
          {hover || checked ? (
            filterImages?.length ? (
              <div className={styles.mask}>{mask}</div>
            ) : null
          ) : null}
        </div>
      </div>
    );
  };
  return (
    <ImageViewer
      trigger={trigger}
      images={filterImages}
      defaultIndex={defaultIndex}
      closeOnOverlay={true}
      closeBtn={false}
    />
  );
};
